import { getTemplate } from "../template-helper";
import { uuidv4 } from "../../util/utils";

const COMPONENT_NAME = "z-tabs" ;

const TEMPLATE_ID = "component-"+COMPONENT_NAME+"-template" ;
const TEMPLATE_URL_BASE = "/static/libs/components/" ;
const TEMPLATE_URL = "/static/libs/components/"+COMPONENT_NAME+".html" ;

export default function register(){
    getTemplate(TEMPLATE_ID, TEMPLATE_URL).then((template)=>{
        getTemplate(TEMPLATE_ID+"-title", TEMPLATE_URL_BASE+"z-tab-title.html").then((templateTitle)=>{
            getTemplate(TEMPLATE_ID+"-contents", TEMPLATE_URL_BASE+"z-tab-contents.html").then((templateContents)=>{
        
                class TabsComponent extends HTMLElement {
                    constructor() {
                        super();

                        
                    }


                    connectedCallback(){
                        this.init() ;
                    }

                    doImport() {
                
                        let rootNode = this.getRootNode();
                        if(rootNode === this) { return ; }
                        if(!rootNode || !rootNode.getElementById){ return ; }
        
                        let head = rootNode;
                        if(rootNode.head){
                            head = rootNode.head ;
                        }
        
                        const styleTag = rootNode.getElementById("style_z_tabs") ;
                        if(styleTag){ return ; }

                        var sInline = document.createElement('style');
                        sInline.id = "style_z_tabs" ;
                        sInline.setAttribute('type', 'text/css');
                        sInline.appendChild(document.createTextNode(`
                            z-tabs .nav-pills { 
                                background: #eeeeee7a;
                                border-radius: .25rem;
                            }
                            z-tabs .nav-pills .nav-link { 
                                border-radius: .25rem;
                                border: 1px solid #DDD;
                                margin-right: 5px;
                                min-width: 75px;
                            }
                        `));
                        head.appendChild(sInline);
                    }

                    init(){
                        this.doImport() ;

                        let innerHTML = this.innerHTML ;
                        const oldContents = this.querySelector(".tab-content") ;
                        if(oldContents){
                            //initial contents was already moved to the contents sub div
                            innerHTML = oldContents.innerHTML ;
                        }
                        this.innerHTML = "" ;

                        const clone = document.importNode(template.content, true);
                        this.appendChild(clone);

                        this.ul = this.querySelector("ul.nav") ;
                        this.contents = this.querySelector(".tab-content") ;
                        if(this.hasAttribute("z-pills")){
                            this.ul.classList.remove("nav-tabs");
                            this.ul.classList.add("nav-pills");
                        }

                        this.contents.innerHTML = innerHTML ;
                    }
                    
                    showTab(zTabId, realTabId){
                        if(zTabId && zTabId.id){
                            zTabId = zTabId.id.replace(/-contents$/, "");
                        }
                        const tabByRealId = this.querySelector('[z-real-id="'+zTabId+'"]') ;
                        if(tabByRealId){
                            zTabId = tabByRealId.id.replace(/-contents$/, "");
                        }
                        const currentTitle = this.ul.querySelector("#"+zTabId+"-title") ;
                        const allTitles = this.ul.querySelectorAll("a.nav-link") ;
                        for(let t of allTitles){
                            if(t !== currentTitle){
                                t.classList.remove("active");
                                t.classList.remove("show");
                            }
                        }
                        if(currentTitle){
                            currentTitle.classList.add("active");
                            currentTitle.classList.add("show");
                        }
                        const currentContents = this.querySelector("#"+zTabId+"-contents") ;
                        const allContents = this.contents.querySelectorAll(".tab-pane") ;
                        for(let c of allContents){
                            if(c !== currentContents){
                                c.classList.remove("active");
                                c.classList.remove("show");
                            }
                        }
                        if(currentContents){
                            currentContents.classList.add("active") ;
                            currentContents.classList.add("show") ;
                        }
                        this.dispatchEvent(new CustomEvent("changetab", { detail: realTabId}));
                        //trigger resize to force tab content (like calendar, grid, etc...) to recompute size
                        window.dispatchEvent(new Event('resize'));
                    }

                    removedTab(zTabId){
                        if(zTabId && zTabId.id){
                            zTabId = zTabId.id;
                        }
                        zTabId = zTabId.replace(/-contents$/, "");
                        const title = this.querySelector("#"+zTabId+"-title") ;
                        if(title){
                            const li = title.closest("li") ;
                            if(li){
                                li.parentElement.removeChild(li) ;
                            }
                        }  
                    }

                    selectTab(tabId){
                        const tab = this.querySelector('[z-real-id="'+tabId+'"]') ;
                        if(tab){
                            tab.showTab();
                        }else{
                            console.error("Unknown tab id "+tabId) ;
                        }
                    }

                    renderTabs(){
                        const allTabs = this.querySelectorAll("z-tab") ;
                        // const allTabs = Array.prototype.filter.call(this.querySelectorAll("z-tab"), c=>{
                        //     c.closest("z-tabs")===this ;
                        // }) ;
                        //const allTabs = Array.prototype.filter.call(this.children, (c=>c.tagName === "Z-TAB")) ;
                        const allSeenTitles = {} ;
                        let firstTabId = null;
                        let firstTabRealId = null;
                        for(let zTab of allTabs){
                            if(zTab.closest("z-tabs")!==this){ continue ; }

                            const zTabTitle = zTab.querySelector("z-tab-title") ;
                            const zTabContents = zTab.querySelector("z-tab-contents") ;
                            let zTabId = zTab.id ;
                            const tabIndex = Array.prototype.indexOf.call(this.querySelectorAll("z-tab"), zTab) ;
                            if(zTabId){
                                zTabId = zTab.id.replace(/-contents$/, "") ;
                            }else{
                                zTabId = zTab.getAttribute("z-tab-id")+"_"+tabIndex ;
                            }
                            if(!firstTabId){
                                firstTabId = zTabId ;
                                firstTabRealId = zTab.getAttribute("z-real-id");
                            }
                            
                            if(zTabTitle && zTabContents){

                                if(!zTab.id){
                                    // first time
                                    zTab.id = zTabId+"-contents" ;
                                    zTab.setAttribute("aria-labelledby", zTabId+"-title") ;
                                    zTab.setAttribute("role", "tabpanel") ;
                                    zTab.className = "tab-pane fade" ;
                                    zTab.removeAttribute("zz-bind-prepared") ;
                                }
    
                                let aTitle = this.ul.querySelector("#"+zTabId+"-title") ;
                                let liTitle = null;
                                if(!aTitle){
                                    liTitle = document.importNode(templateTitle.content, true).children[0];
                                    aTitle = liTitle.querySelector("a");
                                    aTitle.id = zTabId+"-title" ;
                                    aTitle.href = "#"+zTabId+"-contents" ;
                                    // aTitle.setAttribute("data-target", "#"+zTabId+"-contents") ;
                                    aTitle.setAttribute("aria-controls", zTabId+"-contents") ;
                                    aTitle.addEventListener("click", (e)=>{
                                        e.preventDefault() ;
                                        this.showTab(zTabId, zTab.getAttribute("z-real-id")) ;
                                    }) ;
                                    this.ul.appendChild(liTitle);
                                }else{
                                    liTitle = aTitle.parentElement ;
                                }
                                zTab.showTab = ()=>{
                                    this.showTab(zTabId, zTab.getAttribute("z-real-id")) ;
                                } ;
                                const allLiTitles = this.ul.querySelectorAll("li") ;
                                for(let i=0; i<allLiTitles.length; i++){
                                    const li = allLiTitles[i] ;
                                    if(li === liTitle){
                                        if(i !== tabIndex){
                                            if(tabIndex>=allLiTitles.length-1){
                                                this.ul.appendChild(li) ;
                                            }else{
                                                this.ul.insertBefore(li, allLiTitles[tabIndex]) ;
                                            }
                                        }
                                        break;
                                    }
                                }

                                allSeenTitles[zTabId+"-title"] = true ;
                                aTitle.innerHTML = zTabTitle.innerHTML ;
    
                                zTabTitle.style.display = "none" ;
                            }
                        }

                        //remove orphan titles
                        const allTitles = this.ul.querySelectorAll("a.nav-link") ;
                        for(let title of allTitles){
                            if(!allSeenTitles[title.id]){
                                const li = title.parentElement ;
                                li.parentNode.removeChild(li) ;
                            }
                        }

                        if(firstTabId && !this.querySelector(".tab-pane.active")){
                            this.showTab(firstTabId, firstTabRealId) ;
                        }
                    }

                }
                customElements.define(COMPONENT_NAME, TabsComponent);

                class TabComponent extends HTMLElement {
                    constructor() {
                        super();
                        this.style.height = "100%" ;
                    }
                    
                    connectedCallback() {
                        if(this.id && !this.hasAttribute("z-real-id")){
                            this.setAttribute("z-real-id", this.id) ;
                        }
                        this.id = "";
                        this.setAttribute("z-tab-id", "u"+uuidv4()) ;
                        this.zTabs = this.closest("z-tabs") ; 
                        this.renderTab();
                    }

                    disconnectedCallback(){
                        if(this.zTabs){
                            this.zTabs.removedTab(this.id) ;
                        }
                    }

                    renderTab(){
                        const zTabs = this.closest("z-tabs") ;
                        if(zTabs){
                            zTabs.renderTabs() ;
                        }
                    }
                }
                customElements.define("z-tab", TabComponent);
                
                class TabTitleComponent extends HTMLElement {
                    constructor() {
                        super();
                        //rerender on content changes
                        const observer = new MutationObserver((mutations)=>{
                            if(mutations.some((m)=>m.type !== "attributes")){
                                this.connectedCallback() ;
                            }
                        });
                        observer.observe(this, { attributes: true, childList: true, subtree: true });
                       
                    }

                    connectedCallback(){
                        const zTab = this.closest("z-tab") ;
                        if(zTab){
                            zTab.renderTab() ;
                        }
                    }
                }
                customElements.define("z-tab-title", TabTitleComponent);
                
                class TabContentsComponent extends HTMLElement {
                    constructor() {
                        super();
                    }
                    
                    connectedCallback(){
                        const zTab = this.closest("z-tab") ;
                        if(zTab && !zTab.hasAttribute("role")){
                            zTab.renderTab() ;
                        }
                    }
                }
                customElements.define("z-tab-contents", TabContentsComponent);
            }).catch((err)=>{
                throw err ;
            }) ;
        }).catch((err)=>{
            throw err ;
        }) ;
    }).catch((err)=>{
        throw err ;
    }) ;
}
